module.exports = __webpack_public_path__ + "static/img/12.c0e5591.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/5/1/zh/12.png
// module id = ktGg
// module chunks = 0